import { createSelector } from 'reselect';
import { getAllSpaces } from '@core/selectors/space/space.selectors';
import { getRecentlyViewedNavigationBySpaceId } from '@app/selectors/home';

export const getHomeRecentSpaces = createSelector(
  [getAllSpaces, getRecentlyViewedNavigationBySpaceId],
  (spacesMap, recentNavs) => {
    const spaces = Object.values(spacesMap || {});

    return spaces
      .filter((space) => !space.archived && space.objectId in recentNavs)
      .map((space) => ({
        ...space,
        isStarred: !!space.isStarred,
      }));
  }
);
